__turbopack_context__.v({
  "group": "_3S_CnG_group",
  "ivato-reviews": "_3S_CnG_ivato-reviews",
  "pause": "_3S_CnG_pause",
  "root": "_3S_CnG_root",
  "track": "_3S_CnG_track",
  "viewport": "_3S_CnG_viewport",
});
